import type {ExpressionPath} from '@packages/systems/wfdl';

export const EXPERIENCES_BY_VARIATION_ID: ExpressionPath = [
  {in: 'Record', at: 'experiencesByVariationId'},
];

export const EXPERIENCE_ID_PATH: ExpressionPath = [
  {in: 'Record', at: 'experienceId'},
];

export const VARIATION_ID_PATH: ExpressionPath = [
  {in: 'Record', at: 'variationId'},
];

export const CURRENT_VARIATION_ID_PATH: ExpressionPath = [
  {in: 'Record', at: 'currentVariationId'},
];

export const MATCHING_VARIATION_ATOM_ID_PATH: ExpressionPath = [
  {in: 'Record', at: 'matchingVariationAtomId'},
];
